import { normalizeColor } from "grommet/utils";
import * as React from "react";
import styled from "styled-components";
import { useDarkMode } from "../components/DarkModeSwitch";
import Theme from "../utils/Theme";

const TransparentBlockDiv = styled.div`
    position: relative;
    color: ${({ darkMode }) => normalizeColor("text", Theme, darkMode!)};
    * {
        z-index: 1;
    }
    &:before {
        content: "";
        background-color: ${({ darkMode }) => normalizeColor("background", Theme, darkMode)};
        background-size: cover;
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        opacity: 0.65;
        z-index: 0;
        border-radius: 5px;
    }
`;

export const TransparentBlock = ({ children }) => {
    const [isDarkMode] = useDarkMode();

    return <TransparentBlockDiv darkMode={isDarkMode}>{children}</TransparentBlockDiv>;
};
